/**
 * Single source of truth for site-wide constants used in SEO tags,
 * sitemap, JSON-LD, Open Graph, canonical URLs, etc.
 *
 * All dynamic URLs should be built via `absoluteUrl(path)` so we never
 * ship localhost strings to production.
 */

export const SITE = {
  name: 'Prompt Save',
  shortName: 'PromptSave',
  // Short, keyword-friendly tagline — used in <title> templates.
  tagline: 'A gallery of great prompts',
  // Longer description — used in <meta name="description"> and OG.
  description:
    'Discover, save, and remix AI prompts that actually work. A curated gallery of prompts for writing, coding, art, business, and education — built by creators, for creators.',
  // Keywords — modern search engines mostly ignore these but some still read them.
  keywords: [
    'AI prompts',
    'prompt gallery',
    'ChatGPT prompts',
    'Claude prompts',
    'Midjourney prompts',
    'prompt library',
    'prompt sharing',
    'prompt engineering',
    'writing prompts',
    'coding prompts',
  ],
  author: 'Prompt Save',
  twitter: '@promptsave',  // update when real handle exists
  locale: 'en_US',
} as const;

/** Base URL without trailing slash. Falls back to localhost for dev. */
export const SITE_URL = (process.env.NEXT_PUBLIC_SITE_URL || 'http://localhost:3000')
  .replace(/\/+$/, '');

/** Build an absolute URL from a path ("/prompt/abc" → "https://.../prompt/abc"). */
export function absoluteUrl(path: string = '/'): string {
  const p = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${p}`;
}

/** Default Open Graph image for generic pages. */
export const DEFAULT_OG_IMAGE = absoluteUrl('/og-default.svg');
